module.exports = __webpack_public_path__ + "static/img/home_new3.56adb357.jpg";